import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'default', pure: false})
export class DefaultPipe implements PipeTransform {
    transform(value: any, defaultValue = null): any {
        return value ? value : defaultValue;
    }
}
